import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  CardText,
} from "reactstrap";
const TableComponent = ({ header, data }) => {
  const tableaustyles = {
    background: "#3c88c8",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  return (
    <div className="table-responsive">
      <table className="table table-bordered">
        <thead>
          <tr>
            {header.map((columnName, index) => (
              <th
                className=""
                style={{ background: "#50a5f1", color: "white" }}
                key={index}
              >
                {columnName}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length == 0 ? (
            <tr>
              <td colSpan={header.length}>Aucune donnée à afficher</td>
            </tr>
          ) : (
            data.map((rowData, index) => (
              <tr key={index}>
                {Object.entries(rowData).map(([key, value]) =>
                  key !== "index" && key !== "id" ? (
                    <td
                      key={key}
                      className={
                        typeof value === "number" || key == "position_signature"
                          ? "text-end"
                          : ""
                      }
                    >
                      {key == "montant" ||
                      key == "montant_ht" ||
                      key == "prime_emission" ||
                      key == "valeur_action" ||
                      key == "montant_souscrit" ||
                      key == "investissements_"
                        ? value?.toLocaleString("fr-FR", {
                            style: "currency",
                            currency: "EUR",
                          }) || "--"
                        : value == null
                        ? "--"
                        : value}
                    </td>
                  ) : (
                    ""
                  )
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};
export default TableComponent;
